import type { SVGProps } from 'react'
const SvgArrowCards = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={128}
    height={121}
    fill="none"
    viewBox="0 0 128 121"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#202B51"
        d="M116.581 27.542a38 38 0 0 1-5.21 2.61q-.788.336-1.606.59a.9.9 0 0 1-.986-.204.9.9 0 0 1-.194-.296c-.229-.55.091-.92.537-1.167q.49-.282 1.006-.511a40 40 0 0 0 5.694-3.14q.811-.56 1.694-.998c.913-.424 1.695-.185 2.032.77 1.128 3.185 3.104 5.897 4.975 8.635q.322.422.559.9a1.085 1.085 0 0 1-.35 1.415 1.08 1.08 0 0 1-1.46-.083 4.5 4.5 0 0 1-.617-.666 40.6 40.6 0 0 1-3.973-5.807c-.308.06-.274.341-.327.53-1.783 6.305-4.071 12.467-5.587 18.851-.455 1.838-1.984 2.012-3.189.953-2.948-2.602-5.856-5.311-9.137-7.463-8.638-5.688-17.896-6.712-27.568-3.166-9.14 3.288-16.255 9.222-21.653 17.252-2.903 4.326-5.117 8.978-5.715 14.237-.353 3.163-.608 6.35-1.06 9.547-.203 1.477-.507 2.916-1.552 4.107a1.76 1.76 0 0 1-1.855.672c-2.134-.438-3.976-1.583-5.924-2.403-1.323-.555-2.61-1.205-3.972-1.679-3.47-1.204-6.976-1.025-10.443-.11-5.21 1.376-9.86 3.728-13.371 7.955a14.3 14.3 0 0 0-2.854 5.02c-.389 1.307-1.34 1.41-2.42.61C.402 93.287.4 91.42 1.463 89c2.562-5.684 6.813-9.715 12.32-12.55a25.8 25.8 0 0 1 13.89-2.938 23.2 23.2 0 0 1 8.806 2.61 91 91 0 0 1 3.947 2.095c.498.28.6.213.683-.338a51 51 0 0 1 2.262-10.711c5.29-15.045 15.028-25.887 30.41-30.983 10.902-3.613 20.995-1.302 30.153 5.418 1.993 1.456 3.893 3.05 5.816 4.606.435.348.613.366.776-.237 1.348-4.866 3.188-9.61 4.751-14.424.435-1.283.846-2.573 1.305-4.006"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 .624h127.425v119.422H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgArrowCards
